import React, { useState } from 'react';
import { Button, Form, Progress } from 'semantic-ui-react';
import axios from 'axios';

import config from '../../../config';


const FileUploadForm = () => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [uploading, setUploading] = useState(false);

  const controller = new AbortController();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleCancel = () => {
    controller.abort()
    setUploading(false);
    setMessage("Keskeytetty.")
    setStatus("error")
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('file', file);
    setMessage("Ladataan...");
    setStatus("");
    setUploading(true);
    try {
      await axios.post(config.api.uploadFile, formData, {
        signal: controller.signal,
        headers: {
          'content-type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentage);
        },
      });
      setMessage("Valmis!")
      setStatus("success")
    } catch (error) {
      console.error('Error uploading file!');
      setStatus("error")
    } finally {
      setUploading(false);
    }
  };

  return (
    <Form>
      <Form.Field>
        <label>Valitse tiedosto</label>
        <input type="file" onChange={handleFileChange} />
      </Form.Field>
      <Button onClick={handleSubmit}>Lataa</Button>
      <div style={{ 'clear': 'left' }}>
        {message}
      </div>
      <div hidden={!progress}>
        <Progress percent={progress} success={status === "success"} error={status === "error"} />
        <Button onClick={handleCancel}>Keskeytä</Button>
      </div>

    </Form>
  );
};

export default FileUploadForm;



// WEBPACK FOOTER //
// ./src/containers/main/processes/FileUploadForm.js